@if (camera) {
  <div class="wrapper" [class.selectable]="selectable">
    <div class="details">
      <h4>{{camera.title}}</h4>
      <p><small>{{camera.gateway.site.title}}</small></p>
    </div>
    <div [class.no-image]="!camera.last_image" class="crop">
      @if (camera.last_image_url) {
        <img [src]="camera.last_image_url">
      }
    </div>
  </div>
}